(function () {
  var busy = false, openBtn = null;
  function closeInfo() {
    var ov = document.querySelector('.jfn-col-info__ov:not([hidden])');
    if (ov) { ov.hidden = true; }
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); openBtn = null; }
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var b = t.closest('.jfn-col-info');
    if (b) {
      var ov = document.getElementById(b.getAttribute('aria-controls'));
      if (!ov) { return; }
      closeInfo(); ov.hidden = false; b.setAttribute('aria-expanded', 'true'); openBtn = b;
      var x = ov.querySelector('.jfn-col-info__x'); if (x) { x.focus(); }
      return;
    }
    if (t.closest('.jfn-col-info__x') || (t.classList && t.classList.contains('jfn-col-info__ov'))) { closeInfo(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeInfo(); } });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-jfn-col-atc]')) { return; }
    e.preventDefault();
    if (busy) { return; }
    var b = f.querySelector('button[type=submit]');
    if (b && b.disabled) { return; }
    busy = true; if (b) { b.setAttribute('aria-busy', 'true'); b.classList.add('is-loading'); }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok) { throw x.j; }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: x.j, addToCartBtn: b } }));
      })
      .catch(function (err) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: (err && (err.description || err.message)) || '' } }));
        if (b) { b.title = (err && (err.description || err.message)) || ''; }
      })
      .then(function () { busy = false; if (b) { b.removeAttribute('aria-busy'); b.classList.remove('is-loading'); } });
  });
})();
